import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getCreateTicketDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tickets/models/inputs/create-ticket.form-default-values';
import { CreateTicketModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/support-service-lib/src/wrapper/inputs/create-ticket.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { TicketCreateFormStep1Controller } from '../ticket-create-form-step-1/ticket-create-form-step-1.controller';

export interface TicketCreateFormControllerProps {
  onError: SubmitErrorHandler<CreateTicketModel>;
  onSubmit: SubmitHandlerWithDirtyFields<CreateTicketModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const TicketCreateFormController = ({
  onError,
  onSubmit,
  onCancel,
  state,
}: TicketCreateFormControllerProps): React.JSX.Element => {
  return (
    <MultiStepFormProvider<CreateTicketModel>
      useFormProps={{
        mode: 'all',
        defaultValues: getCreateTicketDefaultValues(),
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: [
            'priority',
            'title',
            'description',
            'customerId',
            'networkId',
            'assigneeId',
            'notificationContacts',
            'relatedResources',
          ],
          component: <TicketCreateFormStep1Controller />,
        },
      ]}
    />
  );
};
